export function gendersMatch(genderA: string, genderB: string) {
  return (
    genderA === genderB ||
    (isMaleGender(genderA) && isMaleGender(genderB)) ||
    (isFemaleGender(genderA) && isFemaleGender(genderB))
  )
}

const MALE_GENDERS = ["m", "male"]
function isMaleGender(gender: string) {
  if (!gender) return false
  return MALE_GENDERS.includes(gender.toLowerCase())
}

const FEMALE_GENDERS = ["f", "female"]
function isFemaleGender(gender: string) {
  if (!gender) return false
  return FEMALE_GENDERS.includes(gender.toLowerCase())
}
